module.exports = __webpack_public_path__ + "img/Landingspage_Header.4d66ab17.svg";